/**
 * * Get matching colors
 * @param {Array<Color>} colors
 * @param {Array<HexaItem>} result
 * @returns {Boolean} true if result contains color
 */
function getMatchingColors(colors, result) {
  const colorIds = new Set(colors.map((color) => color.id));
  return result.some((item) => colorIds.has(Number(item.product_color)));
}

export default getMatchingColors;
